module.exports = __webpack_public_path__ + "img/DE00874.aedeb2cf.png";